const BASE = "https://customer-assets-39nsmqrw.emergentagent.net/job_dd3808b8-5511-4e94-8390-1ef7a52a0c1e/artifacts";
const LOCAL = `${process.env.PUBLIC_URL || ""}/assets`;

export const ASSETS = {
  logo: `${BASE}/5vxbit3x_lowpages-logo.png`,
  dashboard: `${LOCAL}/dashboard.webp`,
  editor: `${LOCAL}/editor.webp`,
  laptop: `${LOCAL}/laptop.webp`,
};
